const es = {
  // 🔹 unionDelegationService (Gremios)
  'unionDelegationService.table.title': 'Gremios',
  'unionDelegationService.table.filter_by_name': 'Filtrar por Nombre del Gremio',
  'unionDelegationService.table.filter_by_name_2': 'Filtrar por el Estado del Gremio',
  'unionDelegationService.filter_by_deleted_not_deleted': 'Activo',
  'unionDelegationService.table.filter_by_deleted_deleted': 'Eliminado',
  'unionDelegationService.table.filter_by_deleted_all': 'Todos',
  'unionDelegationService.form.create': 'Crear Gremio',
  'unionDelegationService.table.name': 'Nombre del Gremio',
  'unionDelegationService.table.actions': 'Acciones',
  'unionDelegationService.table.actions.edit': 'Editar Gremio',
  'unionDelegationService.table.actions.delete': 'Eliminar Gremio',
  'unionDelegationService.table.modal.restore.title': 'Restaurar',
  'unionDelegationService.table.modal.restore.phrase': '¿Estás seguro de que deseas restaurar este Gremio?',
  'unionDelegationService.table.modal.restore.button.cancel': 'Cancelar',
  'unionDelegationService.table.actions.restore': 'Restaurar Gremio',
  'unionDelegationService.table.modal.delete.title': 'Eliminar',
  'unionDelegationService.table.modal.delete.phrase': '¿Estás seguro de que deseas eliminar este Gremio?',
  'unionDelegationService.table.modal.delete.button.cancel': 'Cancelar',
  'unionDelegationService.table.modal.delete.button.delete': 'Eliminar',
  'unionDelegationService.table.modal.restore.done': 'Gremio restaurado exitosamente',
  'unionDelegationService.table.modal.delete.done': 'Gremio eliminado exitosamente',
  'unionDelegationService.table.no_data': 'No hay datos disponibles',
  'unionDelegationService.form.update': 'Actualizar Gremio',
  'unionDelegationService.form.unionDelegationServiceName': 'Nombre del Gremio',
  'unionDelegationService.form.cancel': 'Atrás',
  'unionDelegationService.restore.error': 'Error al restaurar el Gremio',

  // 🔹 serviceContractDelegation (Contratos)
  'serviceContractDelegation.table.title': 'Contratos de los Servicios',
  'serviceContractDelegation.table.filter_by_name': 'Filtrar por Nombre de la Contrato',
  'serviceContractDelegation.table.filter_by_name_2': 'Estado del Contracto',
  'serviceContractDelegation.table.filter_by_name3': 'Filtrar por Nombre de Delegacion',
  'serviceContractDelegation.table.filter_by_not_deleted': 'Activo',
  'serviceContractDelegation.table.filter_by_deleted': 'Eliminado',
  'serviceContractDelegation.table.filter_deleted_all': 'Todos',
  'serviceContractDelegation.form.create': 'Crear un Contrato',
  'serviceContractDelegation.form.update': 'Actualizar Contrato',
  'serviceContractDelegation.table.name': 'Nombre del contrato',
  'serviceContractDelegation.table.union': 'Gremio',
  'serviceContractDelegation.table.startDate': 'Fecha de Inicio',
  'serviceContractDelegation.table.endDate': 'Fecha de Fin',
  'serviceContractDelegation.table.actions': 'Acciones',
  'serviceContractDelegation.table.modal.delete.title': 'Eliminar',
  'serviceContractDelegation.table.modal.delete.phrase': '¿Estás seguro de que deseas eliminar este Contrato?',
  'serviceContractDelegation.table.modal.delete.button.cancel': 'Cancelar',
  'serviceContractDelegation.table.modal.delete.button.delete': 'Eliminar',
  'serviceContractDelegation.table.modal.delete.done': 'Contrato eliminado exitosamente',
  'serviceContractDelegation.table.modal.delete.error': 'Error al eliminar el Contrato',
  'serviceContractDelegation.table.modal.restore.title': 'Restaurar',
  'serviceContractDelegation.table.modal.restore.phrase': '¿Estás seguro de que deseas restaurar este Contrato?',
  'serviceContractDelegation.table.modal.restore.button.cancel': 'Cancelar',
  'serviceContractDelegation.table.actions.restore': 'Restaurar Contrato',
  'serviceContractDelegation.table.modal.restore.done': 'Contrato restaurado exitosamente',
  'serviceContractDelegation.restore.error': 'Error al restaurar el Contrato',
  'serviceContractDelegation.table.no_data': 'No hay datos disponibles',
  'serviceContractDelegation.form.serviceContractDelegationName': 'Nombre del Contrato de Servicio',
  'serviceContractDelegation.form.unionName': 'Nombre del Gremio',
  'serviceContractDelegation.form.cancel': 'Atrás',
  'serviceContractDelegation.form.serviceContactName': 'Nombre del Contacto',
  'serviceContractDelegation.restore.success': 'Guardado correctamente',
  'serviceContractDelegation.table.serviceCompany': 'Empresa de Servicio',
  'serviceCompany.form.serviceCompanyName': 'Nombre de la Empresa del Servicio',
  'delegation.form.delegationName': 'Nombre de la Delegacion',
  'serviceContractDelegation.table.filter_by_name4': 'Filtrar por nombre de Compañia',
  'serviceContractDelegation.table.filter_by_name5': 'Filtrar por Fecha',
  'serviceContractDelegation.table.actions.edit': 'Editar Contrato',
  'serviceContractDelegation.table.actions.delete': 'Eliminar Contrato',
  'service.ContractDelegation.date.error': 'La fecha de fin debe ser igual o posterior a la fecha de inicio',
  'serviceContractDelegation.table.executionDate' : 'Fecha de Ejecución',
  'serviceContractDelegation.table.filter_by_name_5' : 'Filtro Fecha de Ejecutación',
  'serviceContractDelegation.table.filter_all': 'Todos',
  'serviceContractDelegation.table.filter_pendiente' : 'Pendientes',
  'service.ContractDelegation.dateExecution.error' : "La fecha de Ejecución tiene que estar entre Fecha inicio y Fecha Fin",

  // 🔹 serviceContactDelegation (Contactos)
  'serviceContactDelegation.table.title': 'Contacto de los Servicios',
  'serviceContact.table.filter_by_name': 'Filtrar por Nombre de Contrato',
  'serviceContactDelegation.table.button.create': 'Crear Delegación de Contacto de Servicio',
  'serviceContactDelegation.table.filter_by_name': 'Filtrar por Nombre de Contrato',
  'serviceContactDelegation.table.filter_by_name_2': 'Estado del Contacto',
  'serviceContactDelegation.table.filter_by_not_deleted': 'Activo',
  'serviceContactDelegation.table.filter_by_deleted': 'Eliminado',
  'serviceContactDelegation.table.filter_by_all': 'Todos',
  'serviceContactDelegation.form.create': 'Crear un Contacto',
  'serviceContactDelegation.form.update': 'Actualizar Contacto',
  'serviceContactDelegation.table.name': 'Nombre del contacto',
  'serviceContactDelegation.table.phoneNumber': 'Número de Teléfono',
  'serviceContactDelegation.table.Contract': 'Contrato',
  'serviceContactDelegation.table.actions': 'Acciones',
  'serviceContactDelegation.table.actions.restore': 'Restaurar Contacto',
  'serviceContactDelegation.table.modal.delete.title': 'Eliminar',
  'serviceContactDelegation.table.modal.delete.phrase': '¿Estás seguro de que deseas eliminar este Contacto?',
  'serviceContactDelegation.table.modal.delete.button.cancel': 'Cancelar',
  'serviceContactDelegation.table.modal.delete.button.delete': 'Eliminar',
  'serviceContactDelegation.table.modal.delete.done': 'Contacto eliminada exitosamente',
  'serviceContactDelegation.table.modal.delete.error': 'Error al eliminar el Contacto',
  'serviceContactDelegation.table.modal.restore.title': 'Restaurar',
  'serviceContactDelegation.table.modal.restore.phrase': '¿Estás seguro de que deseas restaurar este Contacto?',
  'serviceContactDelegation.table.modal.restore.button.cancel': 'Cancelar',
  'serviceContactDelegation.table.modal.restore.button.restore': 'Restaurar',
  'serviceContactDelegation.restore.error': 'Error al restaurar la Contacto',
  'serviceContactDelegation.restore.done': 'Contacto restaurada exitosamente',
  'serviceContactDelegation.form.contractName': 'Nombre del Contrato',
  'serviceContactDelegation.form.cancel': 'Atrás',
  'serviceContactDelegation.save.success': 'Guardado correctamente',
  'serviceContractDelegation.table.delegation': 'Nombre de la Delegacion',
  'serviceContactDelegation.table.filter_by_name3': 'Filtro de Telefono',
  'serviceContactDelegation.table.filter_by_name4': 'Filtro de Contacto',
  'serviceContactDelegation.table.filter_by_name5': 'Filtro de Delegacion',
  'serviceContactDelegation.table.ContractDelegation': 'Delegaciones',
  'serviceContactDelegation.table.apellido': 'Apellido',
  'serviceContactDelegation.table.correoElectronico': 'Correo Electronico',
  'serviceContactDelegation.table.actions.edit': 'Editar Contacto',
  'serviceContactDelegation.table.actions.delete': 'Eliminar Contacto',

  // 🔹serviceCompany (Servicios de Compañia)
  'serviceCompany.restore.error': 'Error al Restaurar el Servicio de Compañia',
  'serviceCompany.table.title': 'Empresa de Servicios',
  'serviceCompany.table.modal.delete.done': 'Servicio de Compañia eliminada exitosamente',
  'serviceCompany.table.modal.restore.done': 'Servicio de Compañia restaurada exitosamente',
  'serviceCompanyService.table.filter_by_name': 'Filtrar por nombre Compañia',
  'serviceCompanyService.table.filter_by_name2': 'Filtrar por nombre CIF',
  'serviceCompany.table.filter_by_name_3': 'Filtrar por Estado de Servicio ',
  'serviceCompanyService.filter_by_deleted_not_deleted': 'Activo',
  'serviceCompanyService.table.filter_by_deleted_deleted': 'Eliminado',
  'serviceCompanyService.table.filter_by_deleted_all': 'Todos',
  'serviceCompany.form.create': 'Crear Compañia Servicio',
  'serviceCompany.table.name': 'Nombre del Servicio de la Compañia',
  'serviceCompany.table.CIF': 'CIF',
  'serviceCompany.table.actions': 'Acciones',
  'serviceCompany.table.no_data': 'No hay Datos Disponibles',
  'seviceCompany.table.actions.edit': 'Editar Servicio de la Compañia',
  'serviceCompany.table.actions.delete': 'Borrar Servicio de la Compañia',
  'serviceCompany.table.modal.restore.title': 'Restaurar',
  'serviceCompany.table.modal.delete.title': 'Eliminar',
  'serviceCompany.table.modal.delete.phrase': 'Estas seguro quieres eliminar este Servicio',
  'serviceCompany.table.modal.delete.button.cancel': 'Cancel',
  'serviceCompany.table.modal.delete.button.delete': 'Eliminar',
  'serviceCompany.table.modal.restore.phrase': 'Estas Seguro q deseas restaurar este Servicio',
  'serviceCompany.table.modal.restore.cancel': 'Cancel',
  'serviceCompany.table.actions.restore': 'Restaurar Servicio',
  'serviceCompany.form.update': 'Actualizar Servicio',
  'serviceCompany.form.serviceCompanyServiceName': 'Nombre del Servicio',
  'serviceCompany.form.serviceCompanyServiceCIF': 'CIF',
  'serviceCompany.form.cancel': ' Atrás',
  'delegation.table.title': 'Delegaciones',
  'delegation.table.filter_by_name': 'filtro de Delegaciones',
  'delegation.table.name': 'Delegación'
};


export default es;